import axios from "axios";
import buildUrl from "build-url-ts";
import { CapabilitiesActionNeeded } from "src/types/settings/dashboard";
import { UserProfile } from "src/types/users";
import { SmsVerificationResponse, SmsConfirmResponse, PhoneVerificationStatusResponse } from "src/types/settings/profile";

const BASE_URL = process.env.REACT_APP_API_URL;
const UPDATED_BASE_URL = process.env.REACT_APP_USERS_API_URL;
const userApiUrl = `${UPDATED_BASE_URL}/users/3.0`;
const actionNeededUrl = `${BASE_URL}/api/2.0/capability-mappings`;
const smsVerificationUrl = `${userApiUrl}/sms/verification`;

export const profileApi = {

  fetchUser: async (): Promise<UserProfile> => {
    const url = buildUrl(`${userApiUrl}/me`);
    const response = await axios.get(url);
    return response.data;
  },

  updateUser: async (data): Promise<UserProfile> => {
    const url = buildUrl(`${userApiUrl}/me`);
    const response = await axios.put(
      url,
      data,
    );
    return response.data;
  },

  updatePassword: async (data): Promise<UserProfile> => {
    const url = buildUrl(`${userApiUrl}/change-password`);
    const response = await axios.put(
      url,
      data,
    );
    return response.data;
  },

  updateEmailSignature: async (data): Promise<UserProfile> => {
    const url = buildUrl(`${userApiUrl}/email-signature`);
    const response = await axios.put(
      url,
      data,
    );
    return response.data;
  },

  fetchCapabilitiesActionNeeded : async (): Promise<CapabilitiesActionNeeded[]> => {
    const url = buildUrl(`${actionNeededUrl}/user/action`);
    const response = await axios.get(url);
    return response.data;
  },

  fetchActivatedKeys : async (): Promise<string[]> => {
    const url = buildUrl(`${actionNeededUrl}/user/activated_keys`);
    const response = await axios.get(url);
    return response.data;
  },

  sendSmsVerification: async (phoneNumber: string): Promise<SmsVerificationResponse> => {
    const url = buildUrl(`${smsVerificationUrl}/send`);
    const response = await axios.post(url, { phoneNumber });
    return response.data;
  },

  resendSmsVerification: async (): Promise<SmsVerificationResponse> => {
    const url = buildUrl(`${smsVerificationUrl}/resend`);
    const response = await axios.post(url);
    return response.data;
  },

  confirmSmsVerification: async (token: string): Promise<SmsConfirmResponse> => {
    const url = buildUrl(`${smsVerificationUrl}/confirm`, {
      queryParams: { token }
    });
    const response = await axios.get(url);
    return response.data;
  },

  getPhoneVerificationStatus: async (): Promise<PhoneVerificationStatusResponse> => {
    const url = buildUrl(`${userApiUrl}/phone/status`);
    const response = await axios.get(url);
    return response.data;
  },
};
